import React from 'react';
import SubscribeRecommendation from './SubscribeRecommendation';
import UpgradeRecommendation from './UpgradeRecommendation';

interface RecommendationProps {

}

const Recommendation: React.FC<RecommendationProps> = () => {
    const scenario_type = window.myAppStrapi && window.myAppStrapi.scenario_type ? window.myAppStrapi.scenario_type : '';
    const customer_type = window.myAppStrapi && window.myAppStrapi.customer_type ? window.myAppStrapi.customer_type : '';
    if(scenario_type === '1' || scenario_type === '2' || (scenario_type === '4' && customer_type === 'existing')){
        return <UpgradeRecommendation/>;
    }else if(scenario_type === '3' || (scenario_type === '4' && customer_type === 'new') || scenario_type === '5' || scenario_type === '8'){
        return <SubscribeRecommendation/>;
    }
};

export default Recommendation;